import { styled } from "styled-components";
import { Typography, Box } from "@mui/material";
import type { Theme } from "../../constants/themeConstants";

export const HeaderContainer = styled(Box)`
  margin-bottom: 8px;
  gap: 24px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`;

export const SectionTitle = styled(Typography)<{ $color?: string }>`
  && {
    font-weight: 700;
    margin-bottom: initial;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 700;
    font-size: 40px;
    line-height: 100%;
    letter-spacing: 0%;
    text-transform: uppercase;

    color: ${({ theme, $color }) =>
      $color ?? (theme as Theme).colors.textColor};

    @media (max-width: 768px) {
      font-size: 1.8rem;
    }
  }
`;

export const SectionSubtitle = styled(Typography)`
  color: ${({ theme }) => (theme as Theme).colors.secondary};
`;
